(ns manage.product-selector-page.sections.sorting
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [common.form :as form]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-selector-page.hooks :as hooks]
            [manage.product-selector-page.widgets :as widgets]
            [mate.core :as mc]
            [uix.core :refer [$ defhook defui]]))

(defhook use-sort-clause-field-options []
  (let [field-options (hooks/use-field-options)]
    (filter :sortable field-options)))

(defui sort-clause-field
  [{:keys [control field-name]}]
  (let [field-options (use-sort-clause-field-options)]
    ($ form-field
       {:label "Product field"}
       ($ form/autocomplete-field
          {:control control
           :name field-name
           :field-props {:options field-options}}))))

(defui sort-clause-order
  [{:keys [control field-name]}]
  ($ form-field
     {:label "Order"}
     ($ form/autocomplete-field
        {:control control
         :name field-name
         :field-props {:options hooks/ordering}})))

(defui sort-clause-sort-type
  [{:keys [control field-name]}]
  ($ form-field
     {:label "Event"}
     ($ form/autocomplete-field
        {:control control
         :name field-name
         :field-props {:options hooks/sorting-events}})))

(defui sort-clause-granularity-window
  [{:keys [control field-name]}]
  ($ form-field
     {:label "Time period"}
     ($ form/autocomplete-field
        {:control control
         :name field-name
         :field-props {:options hooks/granularity-window}})))

(defui sort-clause
  [{:keys [control field-name kind]}]
  ($ Box
     {:sx #js {:display "grid"
               :gridTemplateColumns "1fr 1fr"
               :gap 1}}
     (case kind
       "field"
       ($ :<>
          ($ sort-clause-field {:control control :field-name (str field-name ".field")})
          ($ sort-clause-order {:control control :field-name (str field-name ".order")}))
       "metric"
       ($ :<>
          ($ sort-clause-sort-type {:control control :field-name (str field-name ".sort-type")})
          ($ sort-clause-granularity-window {:control control :field-name (str field-name ".granularity-window")})))))

(defui edit []
  (let [{:keys [control]} (form/use-form-context)
        field-name "query.sort"
        {:keys [fields append remove]} (form/use-field-array #js {:control control
                                                                  :name field-name})
        product-store-fields (hooks/use-product-store-fields)]
    ($ Stack
       {:gap 2}
       ($ form-field
          {:label "Sorting method"}
          ($ ToggleButtonGroup
             {:direction "row"
              :value (some-> fields first .-kind)
              :exclusive true
              :onChange (fn [_e value]
                          (remove 0)
                          (when value
                            (append (->js (case value
                                            "field" (hooks/initial-field-sort-clause product-store-fields)
                                            "metric" hooks/initial-metric-sort-clause)))))}
             ($ ToggleButton
                {:value "field"
                 :sx #js {:flex 1}}
                "By product field")
             ($ ToggleButton
                {:value "metric"
                 :sx #js {:flex 1}}
                "By event")
             ($ ToggleButton
                {:value nil
                 :sx #js {:flex 1}}
                "None")))
       (for [[idx sort] (mc/seq-indexed fields)]
         ($ sort-clause
            {:key (.-id sort)
             :kind (.-kind sort)
             :field-name (str field-name "[" idx "]")
             :control control})))))

(defui read []
  (let [{:keys [control]} (form/use-form-context)
        sort (rhf/useWatch #js {:name "query.sort[0]" :control control})]
    (if sort
      (let [{:keys [kind field order sort-type granularity-window]} (->clj sort)
            sort-type->label (into {} (map (juxt :value :label) hooks/sorting-events))
            order->label (into {} (map (juxt :value :label) hooks/ordering))
            granularity-window->label (into {} (map (juxt :value :label) hooks/granularity-window))
            label (case kind
                    "field" field
                    "metric" (get sort-type->label sort-type))
            value (case kind
                    "field" (get order->label order)
                    "metric" (get granularity-window->label granularity-window))]
        ($ form-field
           {:label label}
           ($ :span value)))
      ($ widgets/empty-section-message {:step-label "sorting"}))))

(defui sorting []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Sorting"
        :tooltip "Pick the sorting options to decide the order in which your products appear."}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
